angular.module('mtic.components.dashboards.teacher_general')
.directive('sortIcon', function ($log, EventManager, TeacherDataService) {return {
  templateUrl: 'template.html',
  scope: {
    sortBy: '=',
    sortByTarget: '=',
    sortByOrder: '='
  },
  link: function(scope){
    // var eventManager = new EventManager('sortIcon', scope);
    scope.getIconClass = function(){
      if (scope.sortByTarget === scope.sortBy){
        if (scope.sortByOrder === 'ASC'){
          return 'fa-sort-asc'
        }
        else if (scope.sortByOrder === 'DESC'){
          return 'fa-sort-desc'
        }
      }
      return 'fa-sort'
    }
  }
}})
